import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'

import store from './store/store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production'
    ? '/app/' // Put subdirectory of app on the server for history mode for prod
    : '/',
  routes: [
    {
      path: '*', redirect: '/home' // Redirect to home if not found
    },
    {
      path: '/login/:schoolid?/:pupilid?/:cgid?',
      name: 'Login',
      component: Login,
      props: (route) => ({ query: route.query.token }),
      meta: {
        guest: true
      }
    },

    {
      path: '/home',
      name: '@school',
      meta: {
        requiresAuth: true
      },
      // route level code-splitting
      // this generates a separate chunk (home.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      // component: () => import(/* webpackChunkName: "home" */ './views/HomeTest.vue'),
      children: [
        {
          path: '/notices',
          name: 'School Notices',
          meta: {
            requiresAuth: true,
            possibleNames: [
              'Notices'
            ]
          },
          component: () => import(/* webpackChunkName: "notices" */ './views/Notices.vue')
        },
        {
          path: '/absence',
          name: 'Absence',
          meta: {
            requiresAuth: true,
            possibleNames: [
              'Report an Absence'
            ]
          },
          component: () => import(/* webpackChunkName: "absence" */ './views/Absence.vue')
        },
        {
          path: '/messages',
          name: 'Teacher Messages',
          meta: {
            requiresAuth: true,
            possibleNames: [
              'Messages'
            ]
          },
          component: () => import(/* webpackChunkName: "messages" */ './views/Messages.vue')
        },
        {
          path: '/favourites',
          name: 'Favourites',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "favourites" */ './views/Favourites.vue')
        },
        {
          path: '/calendar',
          name: 'Calendar',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "calendar" */ './views/Calendar.vue')
          // component: () => import(/* webpackChunkName: "calendar" */ './views/CalendarTest.vue')
        },
        {
          path: '/settings',
          name: 'Settings',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue')
        },
        {
          path: '/settingstwo',
          name: 'Settings Two',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "settings" */ './views/SettingsNew.vue')
        },
        {
          path: '/contact',
          name: 'School Contact',
          meta: {
            requiresAuth: true,
            possibleNames: [
              'Contacts'
            ]
          },
          component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue')
        },
        {
          path: '/assessment',
          name: 'Assessments',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "assessment" */ './views/Assessment.vue')
        },

        {
          path: '/spotlight',
          name: 'Spotlight',
          meta: {
            requiresAuth: true,
            possibleNames: [
              'Learning',
              'Completed Learning'
            ]
          },
          component: () => import(/* webpackChunkName: "spotlight" */ './views/SpotlightAssigned.vue')
        },
        {
          path: '/spotlighttest',
          name: 'Spotlight Test',
          meta: {
            requiresAuth: true,
            possibleNames: [
              'Learning',
              'Completed Learning'
            ]
          },
          component: () => import(/* webpackChunkName: "spotlight" */ './views/SpotlightTest.vue')
        },
        {
          path: '/documents',
          name: 'Documents',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "documents" */ './views/Documents.vue')
        },
        {
          path: '/reports',
          name: 'Reports',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "reports" */ './views/Reports.vue')
        },
        {
          path: '/mychild',
          name: 'My Child',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "mychild" */ './views/MyChild.vue')
        },
        {
          path: '/blog',
          name: 'Blog',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "blog" */ './views/Blog.vue')
          // component: () => import(/* webpackChunkName: "blog" */ './views/BlogTest.vue')
        },
        {
          path: '/accounts',
          name: 'Accounts',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "accountstatement" */ './views/AccountStatement.vue')
        },
        {
          path: '/portfolio',
          name: 'Learning Portfolio',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "portfolio" */ './views/Portfolio.vue')
        },
        {
          path: '/newsletters',
          name: 'Newsletters',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "newsletters" */ './views/Newsletters.vue')
        },
        {
          path: '/sickbay',
          name: 'Sickbay',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "sickbay" */'./views/Sickbay.vue')
        },
        {
          path: '/permissionslips',
          name: 'Permission Slips',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "permissionslips" */'./views/PermissionSlips.vue')
        },
        {
          path: '/guidance',
          name: 'Guidance',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "guidance" */'./views/Guidance.vue')
        },
        // this is for Spotlight Upload
        {
          path: '/spotlightmyupload',
          name: 'Spotlight Upload',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "spotlightMyUpload" */ './views/SpotlightMyUpload.vue')
        },
        {
          path: '/booking',
          name: 'Interview',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "booking" */ './views/Interview.vue')
        },
        {
          path: '/pin',
          name: 'Enter Pin',
          meta: {
            guest: true,
            requiresAuth: true
          },
          component: () => import('./views/Pin.vue')
        },
        {
          path: '/chat',
          name: 'Chat',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "chat" */ './views/TeacherCaregiverChat/BeginChat.vue')
        },
        {
          path: '/kids',
          name: 'Link Kids',
          meta: {
            guest: true,
            requiresAuth: true
          },
          component: () => import('./views/Kids.vue')
        },
        {
          path: '/customDocuments',
          name: 'FODS',
          meta: {
            guest: true,
            requiresAuth: true
          },
          component: () => import('./views/CustomDocuments.vue')
        },
        {
          path: '/sportsMessages',
          name: 'Sports Messages',
          meta: {
            guest: true,
            requiresAuth: true
          },
          component: () => import('./views/SportsMessages.vue')
        }
      ]
    }
  ]
  // scrollBehavior (to, from, savedPosition) { // For scrolling to top or saved position when going back
  //   var returnVar
  //   // if (savedPosition) {
  //   //   returnVar = savedPosition
  //   // } else {
  //   if (to.path === '/home') {
  //     return
  //   }
  //   returnVar = { x: 0, y: 0 }
  //   // }
  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => { // Delay of 200ms for transitions
  //       resolve(returnVar)
  //     }, 500)
  //   })
  // }

  // scrollBehavior (to, from, savedPosition) {
  // console.log('do nothing')
  // console.log(router.app.$vuetify)
  // if (to.path !== '/home') {
  //   router.app.$vuetify.goTo(0)
  // }
  // }
})

// router.afterEach((to, from) => {
//   setTimeout(() => { // Delay of 200ms for transitions
//     scrollTo(0, 0)
//   }, 500)
// })

router.beforeEach((to, from, next) => {
  var menuItemIsEnabled = false

  if (to.path === '/app/manifest.json') {
    next()
    return
  } else if (to.path === '/pin') {
    menuItemIsEnabled = true
  }

  if (typeof store.state.menuConfig[to.name] === 'undefined') {
    if (typeof to.meta.possibleNames !== 'undefined') {
      to.meta.possibleNames.forEach(element => {
        if (typeof store.state.menuConfig[element] !== 'undefined') {
          menuItemIsEnabled = true
        }
      })
    }
  } else {
    menuItemIsEnabled = true
  }

  if (to.path !== '/home' && to.path !== '/login' && to.path !== '/pin' && menuItemIsEnabled === false) {
    next('/home')
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
        next()
        return
      }
      next('/login')
    } else {
      next()
    }
  }
})

export default router
